import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ServerApiService } from "src/app/shared/services/server-api.service";
import { perCapitaData } from "./baseline-contract-constants";
import { CommonService } from "./../../../../shared/services/common.service";
import { PerCapitaBaselineCalculationService } from './per-capita-baseline-calculation/percapita-baseline-calculation.service';
import { ContractExpectationCalculationService } from './per-capita-baseline-calculation/contract-expectation-calculation.service';

@Injectable({
  providedIn:'root'
})
export class BaseLineService {
  constructor(
    private http: HttpClient,
    private serverApiService: ServerApiService,
    private commonService: CommonService,
    private contractExpectationCalculationService: ContractExpectationCalculationService,
    private perCapitaBaselineCalculationService: PerCapitaBaselineCalculationService
  ) {}
  private formularyData = ["NA"];

  private dealAdoptionCurveMonth: any = null;
  private dealAdoptionCurve: any = null;

  private noDealAdoptionCurveMonth: any = null;
  private noDealAdoptionCurve: any = null;

  updatedTableData(perCapitaData, type, perCapFormulary?,userDefinedData?) {
    const eligiblePatientList = perCapitaData["eligiblePatient"][
      "tableData"
    ].filter((k) =>
      k.every(
        (e) =>
          e.value !== "Adjusted Payer Lives" &&
          e.value !== "Patient Eligibility Factor (%)" &&
          e.value !== "Total Eligible Patient Count"
      )
    );
    const units = perCapitaData["units"]["tableData"];
    const trx = perCapitaData["TRx"]["tableData"];
    const TRxSharePercent = perCapitaData["TRxSharePercent"]["tableData"];
    const livesToUnits = perCapitaData["livesToUnits"]["tableData"];
    const scalingFactor = perCapitaData["scalingFactor"]; //need to update it
    const unitsToTrx = perCapitaData["unitsToTrx"]["tableData"]; //need to update it
    const finalArray: any = [];
    const previousQuarter: number = this.getPreviousQuarterIndex(perCapitaData);
    const formularyForProducts = perCapitaData["formularyData"];
    units.forEach((element, index) => {
      switch (type) {
        case "baseline":
          finalArray.push([
            element[0],
            eligiblePatientList[index][previousQuarter],
            TRxSharePercent[index][previousQuarter],
            {
              value: perCapFormulary?.find((item) =>{return item[0].value == element[0].value}) ? perCapFormulary.find((item) =>{return item[0].value == element[0].value})[1].value : formularyForProducts.find((item) =>{return item.Competitor == element[0].value})["Formulary"],
              // value: formularyForProducts.find((item) =>{return item.Competitor == element[0].value})["Formulary"],
              type: "dropDown",
              dataType: "text",
              options: this.formularyData,
            },
          ]);
          break;
        case "baselinePopup":
          finalArray.push([
            element[0],
            eligiblePatientList[index][previousQuarter],
            element[previousQuarter],
            TRxSharePercent[index][previousQuarter],
            livesToUnits[index][previousQuarter],
            {
              value: scalingFactor[previousQuarter-1],
              type: "data",
              dataType: "number",
            },
            unitsToTrx[index][previousQuarter],
            {
              value: perCapFormulary?.find((item) =>{return item[0].value == element[0].value}) ? perCapFormulary.find((item) =>{return item[0].value == element[0].value})[1].value : formularyForProducts.find((item) =>{return item.Competitor == element[0].value})["Formulary"],
              // value: formularyForProducts.find((item) =>{return item.Competitor == element[0].value})["Formulary"],
              type: "dropDown",
              dataType: "text",
              options: this.formularyData,
            },
            trx[index][previousQuarter],
          ]);
          break;
        case "deal":
          let peakPatientColumn = {
            value: "",
            type: "data",
            dataType: "string",
          };
          if (userDefinedData[index].base.IsCompanyProduct === true) {
            peakPatientColumn = {
              value: "0",
              type: "input",
              dataType: "number",
            };
          }
          let sourceAllocationAndMultiproductValueDeal = {
            value: "0",
            type: "input",
            dataType: "number",
          };
          if (userDefinedData[index].base.IsCompanyProduct === true) {
            sourceAllocationAndMultiproductValueDeal = {
              value: "",
              type: "data",
              dataType: "string",
            };
          }
          finalArray.push([
            {
              value: perCapFormulary?.find((item) =>{return item[0].value == element[0].value}) ? perCapFormulary.find((item) =>{return item[0].value == element[0].value})[1].value : formularyForProducts.find((item) =>{return item.Competitor == element[0].value})["Formulary"],
              // value: perCapFormulary?.find((item) =>{return item[0].value == element[0].value}) ? perCapFormulary.find((item) =>{return item[0].value == element[0].value})[1].value : formularyForProducts[index]["Formulary"],
              type: "dropDown",
              dataType: "text",
              options: this.formularyData,
            },
            peakPatientColumn,
            this.commonService.deepCopy(
              sourceAllocationAndMultiproductValueDeal
            ),
            this.commonService.deepCopy(
              sourceAllocationAndMultiproductValueDeal
            ),
          ]);
          break;
        case "dealPopup":
          let peakPatientColumnPopup = {
            value: "",
            type: "data",
            dataType: "string",
          };
          if (userDefinedData[index].base.IsCompanyProduct === true) {
            peakPatientColumnPopup = {
              value: "0",
              type: "data",
              dataType: "number",
            };
          }
          let sourceAllocationAndMultiproductValueDealPopup = {
            value: "0",
            type: "data",
            dataType: "number",
          };
          if (userDefinedData[index].base.IsCompanyProduct === true) {
            sourceAllocationAndMultiproductValueDealPopup = {
              value: "",
              type: "data",
              dataType: "string",
            };
          }
          finalArray.push([
            element[0],
            {
              value: perCapFormulary?.find((item) =>{return item[0].value == element[0].value}) ? perCapFormulary.find((item) =>{return item[0].value == element[0].value})[1].value : formularyForProducts.find((item) =>{return item.Competitor == element[0].value})["Formulary"],
              // value: formularyForProducts.find((item) =>{return item.Competitor == element[0].value})["Formulary"],
              type: "dropDown",
              dataType: "text",
              options: this.formularyData,
            },
            peakPatientColumnPopup,
            element[previousQuarter],
            trx[index][previousQuarter],
            TRxSharePercent[index][previousQuarter],
            sourceAllocationAndMultiproductValueDealPopup,
            sourceAllocationAndMultiproductValueDealPopup,
          ]);
          break;
        case "noDeal":
          let peakPatientColumnNoDeal = {
            value: "",
            type: "data",
            dataType: "string",
          };
          if (userDefinedData[index].base.IsCompanyProduct === true) {
            peakPatientColumnNoDeal = {
              value: "0",
              type: "input",
              dataType: "number",
            };
          }
          let sourceAllocationAndMultiproductValueNoDeal = {
            value: "0",
            type: "input",
            dataType: "number",
          };
          if (userDefinedData[index].base.IsCompanyProduct === true) {
            sourceAllocationAndMultiproductValueNoDeal = {
              value: "",
              type: "data",
              dataType: "string",
            };
          }
          finalArray.push([
            {
              // value: formularyForProducts.find((item) =>{return item.Competitor == element[0].value})["Formulary"],
              value: perCapFormulary?.find((item) =>{return item[0].value == element[0].value}) ? perCapFormulary.find((item) =>{return item[0].value == element[0].value})[1].value : formularyForProducts.find((item) =>{return item.Competitor == element[0].value})["Formulary"],
              type: "dropDown",
              dataType: "text",
              options: this.formularyData,
            },
            peakPatientColumnNoDeal,
            this.commonService.deepCopy(
              sourceAllocationAndMultiproductValueNoDeal
            ),
            this.commonService.deepCopy(
              sourceAllocationAndMultiproductValueNoDeal
            ),
          ]);
          break;
        case "noDealPopup":
          let peakPatientColumnNoDealPopup = {
            value: "",
            type: "data",
            dataType: "string",
          };
          if (index == 0) {
            peakPatientColumnNoDealPopup = {
              value: "0",
              type: "data",
              dataType: "number",
            };
          }
          let sourceAllocationAndMultiproductValueNoDealPopUP = {
            value: "0",
            type: "data",
            dataType: "number",
          };
          if (userDefinedData[index].base.IsCompanyProduct === true) {
            sourceAllocationAndMultiproductValueNoDealPopUP = {
              value: "",
              type: "data",
              dataType: "string",
            };
          }
          finalArray.push([
            element[0],
            {
              value: perCapFormulary?.find((item) =>{return item[0].value == element[0].value}) ? perCapFormulary.find((item) =>{return item[0].value == element[0].value})[1].value : formularyForProducts.find((item) =>{return item.Competitor == element[0].value})["Formulary"],
              // value: formularyForProducts.find((item) =>{return item.Competitor == element[0].value})["Formulary"],
              type: "dropDown",
              dataType: "text",
              options: this.formularyData,
            },
            peakPatientColumnNoDealPopup,
            element[previousQuarter],
            trx[index][previousQuarter],
            TRxSharePercent[index][previousQuarter],
            sourceAllocationAndMultiproductValueNoDealPopUP,
            sourceAllocationAndMultiproductValueNoDealPopUP
          ]);
          break;
      }
    });
    return finalArray;
  }
  private getPreviousQuarter(perCapitaData, contractDate) {
    const date = new Date(contractDate);
    const month = date.getMonth();
    let year: any = date.getFullYear();

    let quarter: string;

    if (month >= 0 && month <= 2) {
      quarter = "Q4";
      year = year - 1;
    } else if (month >= 3 && month <= 5) {
      quarter = "Q1";
    } else if (month >= 6 && month <= 8) {
      quarter = "Q2";
    } else {
      quarter = "Q3";
    }
    return quarter + "-" + year.toString().slice(-2);
  }
  getPreviousQuarterIndex(perCapitaData) {
    let indexValue =
      perCapitaData.TRx.heading.indexOf(
        this.getPreviousQuarter(
          perCapitaData,
          perCapitaData.contractPeriod.ContractStartDate
        )
      ) > 0
        ? perCapitaData.TRx.heading.indexOf(
            this.getPreviousQuarter(
              perCapitaData,
              perCapitaData.contractPeriod.ContractStartDate
            )
          )
        : 1;
    return indexValue;
  }
  updateBaselineCalculation(
    originalData,
    userDefinedData,
    dealType,
    modelImpact,
    userDefinedScenarioData
  ) {
    let calculatedData: any;
    if (modelImpact == "Peak Patient Count") {
      calculatedData = this.perCapitaBaselineCalculationService.calculatePeakPatientCountData(
        originalData,
        userDefinedData,
        dealType,
        userDefinedScenarioData
      );
      // calculatedData = this.getPeakPatientCountData(
      //   originalData,
      //   userDefinedData,
      //   dealType
      // );
    } else if (modelImpact == "Peak Patient Percentage") {
      calculatedData = this.perCapitaBaselineCalculationService.convertPercentageToCount(
        originalData,
        userDefinedData,
        dealType,
        userDefinedScenarioData
      );
      // calculatedData = this.getPeakPatientPercentageData(
      //   originalData,
      //   userDefinedData,
      //   dealType
      // );
    }
    
    return calculatedData;
  }

  getPeakPatientCountData(originalData, userDefinedData, dealType) {
    if (dealType == "deal") {
      let totalTrx = 0;
      let totalSourceAllocation = 0;
      let multiProductImpact = 0;
      let dealUnitValuetoAdjust = 0;
      originalData.tableData.deal.allColumns.map(
        (dealDatarow, dealIndex, dealArray) => {
          totalSourceAllocation =
            totalSourceAllocation +
            ((isNaN(userDefinedData[dealIndex][2]) ||
              userDefinedData[dealIndex][2]) == ""
              ? 0
              : parseInt(userDefinedData[dealIndex][2]));
          multiProductImpact =
            multiProductImpact +
            (isNaN(userDefinedData[dealIndex][3]) ||
            userDefinedData[dealIndex][3] == ""
              ? 0
              : parseInt(userDefinedData[dealIndex][3]));
        }
      );
      originalData.tableData.baseline.allColumns.map(
        (baselineRow, baselineRowIndex, baselineArray) => {
          //console.log(baselineRow)
          originalData.tableData.deal.allColumns.map(
            (dealDatarow, dealIndex) => {
              if (baselineRowIndex == dealIndex) {
                if (baselineRowIndex == 0) {
                  dealDatarow.map((dealDataObj, dealColumnindex, dealArray) => {
                    if (dealColumnindex == 3) {
                      //unit calculation

                      //units = peek patiant count * livestounit factor * scaling factor //need to add scaling factor
                      let unitValue =
                        userDefinedData[baselineRowIndex][1] *
                        originalData["finalQuarterData"]["data"][
                          baselineRowIndex
                        ][4]["value"] *
                        originalData["finalQuarterData"]["data"][
                          baselineRowIndex
                        ][5]["value"];
                      if (unitValue > 0) {
                        dealArray[dealColumnindex]["value"] =
                          Math.round(unitValue);
                      } else {
                        dealArray[dealColumnindex]["value"] = 0;
                        dealUnitValuetoAdjust += Math.abs(unitValue);
                      } // * Lives to unit factor * scaling factor
                      //originalData.tableData.noDeal.allColumns[dealIndex]['dealColumnindex']['value'] =
                      //console.log(baselineRow)
                    }
                    //TRx calculation units * units to Trx

                    if (dealColumnindex == 4) {
                      dealArray[dealColumnindex]["value"] = Math.round(
                        dealArray[dealColumnindex - 1]["value"] /
                          originalData["finalQuarterData"]["data"][
                            baselineRowIndex
                          ][6]["value"]
                      );
                    }
                    //trx percentage calcualtion moved to separate loop
                    // if (dealColumnindex == 5) {
                    //   dealArray[dealColumnindex]["value"] = (
                    //     (dealArray[dealColumnindex - 1]["value"] / totalTrx) *
                    //     100
                    //   ).toFixed(2); //need to update totalTrx;
                    // }
                    if (dealColumnindex == 5) {
                      totalTrx =
                        totalTrx +
                        (isNaN(dealArray[4]["value"]) ||
                        dealArray[4]["value"] == ""
                          ? 0
                          : parseInt(dealArray[4]["value"]));
                    }
                    if (dealColumnindex == 6) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][2];
                    }
                    if (dealColumnindex == 7) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][3];
                    }
                    if (dealColumnindex == 2) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][1];
                    }
                  });
                } else {
                  dealDatarow.map((dealDataObj, dealColumnindex, dealArray) => {
                    if (dealColumnindex == 3) {
                      // unit column
                      if (totalSourceAllocation == 0) {
                        let unitValue =
                          originalData.finalQuarterData.data[
                            baselineRowIndex
                          ][2]["value"] -
                          (originalData.tableData.deal.allColumns[0][
                            dealColumnindex
                          ]["value"] -
                            //last quarter unit of client baselineArray[0][2]["value"]) *
                            originalData.finalQuarterData.data[0][2]["value"]) *
                            (100 /
                              (originalData.tableData.deal.allColumns.length -
                                1) /
                              100) +
                          (parseInt(userDefinedData[baselineRowIndex][3]) /
                            100) *
                            (originalData.tableData.deal.allColumns[0][
                              dealColumnindex
                            ]["value"] -
                              //last quarter unit of client baselineArray[0][2]["value"]); //
                              originalData.finalQuarterData.data[0][2][
                                "value"
                              ]);
                        if (unitValue > 0) {
                          dealArray[dealColumnindex]["value"] =
                            Math.round(unitValue);
                        } else {
                          dealArray[dealColumnindex]["value"] = 0;
                          dealUnitValuetoAdjust += Math.abs(unitValue);
                        }
                        //competortor unit of last quarter baselineArray[baselineRowIndex][2]["value"] -
                      } else {
                        let unitValue =
                          originalData.finalQuarterData.data[
                            baselineRowIndex
                          ][2]["value"] -
                          ((originalData.tableData.deal.allColumns[0][
                            dealColumnindex
                          ]["value"] -
                            //last quarter unit of client baselineArray[0][2]["value"]) *
                            originalData.finalQuarterData.data[0][2]["value"]) *
                            parseInt(userDefinedData[baselineRowIndex][2])) /
                            100 +
                          (parseInt(userDefinedData[baselineRowIndex][3]) /
                            100) *
                            (originalData.tableData.deal.allColumns[0][
                              dealColumnindex
                            ]["value"] -
                              //last quarter unit of client baselineArray[0][2]["value"]); //
                              originalData.finalQuarterData.data[0][2][
                                "value"
                              ]);
                        if (unitValue > 0) {
                          dealArray[dealColumnindex]["value"] =
                            Math.round(unitValue);
                        } else {
                          dealArray[dealColumnindex]["value"] = 0;
                          dealUnitValuetoAdjust += Math.abs(unitValue);
                        }
                        //competortor unit of last quarter baselineArray[baselineRowIndex][2]["value"] -
                      }
                    }
                    //TRx calculation units * units to Trx
                    if (dealColumnindex == 4) {
                      dealArray[dealColumnindex]["value"] = Math.round(
                        dealArray[dealColumnindex - 1]["value"] /
                          originalData["finalQuarterData"]["data"][
                            baselineRowIndex
                          ][6]["value"]
                      );
                      totalTrx =
                        totalTrx +
                        (isNaN(dealArray[4]["value"]) ||
                        dealArray[4]["value"] == ""
                          ? 0
                          : parseInt(dealArray[4]["value"]));
                    }
                    // if (dealColumnindex == 5) {
                    //   dealArray[dealColumnindex]["value"] = (
                    //     (dealArray[dealColumnindex - 1]["value"] / totalTrx) *
                    //     100
                    //   ).toFixed(2); //need to update totalTrx;
                    // }
                    if (dealColumnindex == 5) {
                    }
                    if (dealColumnindex == 6) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][2];
                    }
                    if (dealColumnindex == 7) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][3];
                    }
                    if (dealColumnindex == 2) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][1];
                    }
                  });
                }
              }
            }
          );
        }
      );
      //trx percenatge calculation
      originalData.tableData.deal.allColumns.map(
        (dealDatarow, dealIndex, dealArray) => {
          dealDatarow.map((dealDataObj, dealColumnIndex, dealInnerArray) => {
            if (dealColumnIndex == 5) {
              dealArray[dealIndex][dealColumnIndex]["value"] = (
                (dealArray[dealIndex][dealColumnIndex - 1]["value"] /
                  totalTrx) *
                100
              ).toFixed(2);
            }
          });
        }
      );
      if (dealUnitValuetoAdjust > 0) {
        originalData.tableData.deal.allColumns[0][3]["value"] = Math.round(
          originalData.tableData.deal.allColumns[0][3]["value"] -
            dealUnitValuetoAdjust
        );
        originalData.tableData.deal.allColumns[0][2]["value"] = Math.round(
          originalData.tableData.deal.allColumns[0][3]["value"] /
          (originalData["finalQuarterData"]["data"][0][4]["value"] *
            originalData["finalQuarterData"]["data"][0][5]["value"])
        );

        originalData.tableData.deal.allColumns[0][4]["value"] = Math.round(
          originalData.tableData.deal.allColumns[0][3]["value"] /
            originalData["finalQuarterData"]["data"][0][6]["value"]
        );
        totalTrx=0;

        originalData.tableData.deal.allColumns.map(
          (dealDatarow, dealIndex, dealArray) => {
            dealDatarow.map((dealDataObj, dealColumnIndex, dealInnerArray) => {
              if (dealColumnIndex == 5) {
                totalTrx += 
                  dealArray[dealIndex][dealColumnIndex - 1]["value"];
              }
            });
          }
        );

        originalData.tableData.deal.allColumns.map(
          (dealDatarow, dealIndex, dealArray) => {
            dealDatarow.map((dealDataObj, dealColumnIndex, dealInnerArray) => {
              if (dealColumnIndex == 5) {
                dealArray[dealIndex][dealColumnIndex]["value"] = (
                  (dealArray[dealIndex][dealColumnIndex - 1]["value"] /
                    totalTrx) *
                  100
                ).toFixed(2);
              }
            });
          }
        );
        // originalData.tableData.deal.allColumns[0][5]["value"] = (
        //   (originalData.tableData.deal.allColumns[0][4]["value"] / totalTrx) *
        //   100
        // ).toFixed(2);
        //need to update the source allocation and multi product
        // originalData.tableData.deal.allColumns.map((dealDatarow, dealIndex) => {
        //   dealDatarow.map((dealDataObj, dealColumnindex, dealArray) => {
        //     if (dealIndex !== 0) {
        //       if (dealColumnindex == 6) {
        //         dealArray[dealColumnindex]["value"] = Math.abs(
        //           ((originalData.tableData.deal.allColumns[dealIndex][3][
        //             "value"
        //           ] -
        //             parseFloat(
        //               originalData.finalQuarterData.data[dealIndex][3]["value"]
        //             )) /
        //             (parseFloat(
        //               originalData.finalQuarterData.data[0][3]["value"]
        //             ) -
        //               originalData.tableData.deal.allColumns[0][3]["value"])) *
        //             100
        //         ).toFixed(2);
        //         //units of last querter - units of orignal value of competot produtct/units of last quarter - units of orignal value of  cliet produt)* 100
        //       }
        //     }
        //   });
        // });
      }
    } else if ((dealType == "noDeal")) {
      let totalTrx = 0;
      let totalSourceAllocation = 0;
      let multiProductImpact = 0;
      let noDealUnitValuetoAdjust = 0;
      originalData.tableData.noDeal.allColumns.map(
        (dealDatarow, dealIndex, dealArray) => {
          totalSourceAllocation =
            totalSourceAllocation +
            (isNaN(userDefinedData[dealIndex][2]) ||
            userDefinedData[dealIndex][2] == ""
              ? 0
              : parseInt(userDefinedData[dealIndex][2]));
          multiProductImpact =
            multiProductImpact +
            (isNaN(userDefinedData[dealIndex][3]) ||
            userDefinedData[dealIndex][3] == ""
              ? 0
              : parseInt(userDefinedData[dealIndex][3]));
        }
      );
      originalData.tableData.baseline.allColumns.map(
        (baselineRow, baselineRowIndex, baselineArray) => {
          //console.log(baselineRow)
          originalData.tableData.noDeal.allColumns.map(
            (noDealDatarow, noDealIndex) => {
              if (baselineRowIndex == noDealIndex) {
                if (baselineRowIndex == 0) {
                  noDealDatarow.map(
                    (noDealDataObj, noDealColumnIndex, noDealArray) => {
                      if (noDealColumnIndex == 3) {
                        //unit calculation
                        //units = peek patiant count * livestounit factor * scaling factor //need to add scaling factor
                        let unitValue =
                          userDefinedData[baselineRowIndex][1] *
                          originalData["finalQuarterData"]["data"][
                            baselineRowIndex
                          ][4]["value"] *
                          originalData["finalQuarterData"]["data"][
                            baselineRowIndex
                          ][5]["value"];
                        if (unitValue > 0) {
                          noDealArray[noDealColumnIndex]["value"] =
                            Math.round(unitValue);
                        } else {
                          noDealArray[noDealColumnIndex]["value"] = 0;
                          noDealUnitValuetoAdjust += Math.abs(unitValue);
                        }
                        // * Lives to unit factor * scaling factor
                        //originalData.tableData.noDeal.allColumns[noDealIndex]['noDealColumnIndex']['value'] =
                        //console.log(baselineRow)
                      }
                      //TRx calculation units * units to Trx
                      //let totalTrx = 0;
                      if (noDealColumnIndex == 4) {
                        noDealArray[noDealColumnIndex]["value"] = Math.round(
                          noDealArray[noDealColumnIndex - 1]["value"] /
                            originalData["finalQuarterData"]["data"][
                              baselineRowIndex
                            ][6]["value"]
                        );
                        totalTrx =
                          totalTrx +
                          (isNaN(noDealArray[4]["value"]) ||
                          noDealArray[4]["value"] == ""
                            ? 0
                            : parseInt(noDealArray[4]["value"]));
                      }
                      // if (noDealColumnIndex == 5) {
                      //   noDealArray[noDealColumnIndex]["value"] = (
                      //     (noDealArray[noDealColumnIndex - 1]["value"] /
                      //       totalTrx) *
                      //     100
                      //   ).toFixed(2);
                      // }

                      if (noDealColumnIndex == 6) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][2];
                      }
                      if (noDealColumnIndex == 7) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][3];
                      }
                      if (noDealColumnIndex == 2) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][1];
                      }
                    }
                  );
                } else {
                  noDealDatarow.map(
                    (noDealDataObj, noDealColumnIndex, noDealArray) => {
                      if (noDealColumnIndex == 3) {
                        // unit column
                        //console.log(totalSourceAllocation)
                        if (totalSourceAllocation == 0) {
                          let unitValue =
                            originalData.finalQuarterData.data[
                              baselineRowIndex
                            ][2]["value"] -
                            (originalData.tableData.noDeal.allColumns[0][
                              noDealColumnIndex
                            ]["value"] -
                              //last quarter unit of client baselineArray[0][2]["value"]) *
                              originalData.finalQuarterData.data[0][2][
                                "value"
                              ]) *
                              (100 /
                                (originalData.tableData.noDeal.allColumns
                                  .length -
                                  1) /
                                100) +
                            (parseInt(userDefinedData[baselineRowIndex][3]) /
                              100) *
                              (originalData.tableData.noDeal.allColumns[0][
                                noDealColumnIndex
                              ]["value"] -
                                //last quarter unit of client baselineArray[0][2]["value"]); //
                                originalData.finalQuarterData.data[0][2][
                                  "value"
                                ]);
                          if (unitValue > 0) {
                            noDealArray[noDealColumnIndex]["value"] =
                              Math.round(unitValue);
                          } else {
                            noDealArray[noDealColumnIndex]["value"] = 0;
                            noDealUnitValuetoAdjust += Math.abs(unitValue);
                          }
                          //competortor unit of last quarter baselineArray[baselineRowIndex][2]["value"] -
                        } else {
                          let unitValue =
                          originalData.finalQuarterData.data[baselineRowIndex][2]["value"] -
                            ((originalData.tableData.noDeal.allColumns[0][
                              noDealColumnIndex
                            ]["value"] -
                              //last quarter unit of client baselineArray[0][2]["value"]) *
                              originalData.finalQuarterData.data[0][2][
                                "value"
                              ]) *
                              parseInt(userDefinedData[baselineRowIndex][2])) /
                              100 +
                            // parseInt(userDefinedData[baselineRowIndex][2]) /
                            //   100 +
                            (userDefinedData[baselineRowIndex][3] / 100) *
                              (originalData.tableData.noDeal.allColumns[0][
                                noDealColumnIndex
                              ]["value"] -
                                //last quarter unit of client baselineArray[0][2]["value"]); //
                                originalData.finalQuarterData.data[0][2][
                                  "value"
                                ]);
                          if (unitValue > 0) {
                            noDealArray[noDealColumnIndex]["value"] =
                              Math.round(unitValue);
                          } else {
                            noDealArray[noDealColumnIndex]["value"] = 0;
                            noDealUnitValuetoAdjust += Math.abs(unitValue);
                          }
                        }
                      }
                      //TRx calculation units * units to Trx
                      if (noDealColumnIndex == 4) {
                        noDealArray[noDealColumnIndex]["value"] = Math.round(
                          noDealArray[noDealColumnIndex - 1]["value"] /
                            // baselineArray[baselineRowIndex][6]["value"]
                            originalData["finalQuarterData"]["data"][
                              baselineRowIndex
                            ][6]["value"]
                        );
                        totalTrx =
                          totalTrx +
                          (isNaN(noDealArray[4]["value"]) ||
                          noDealArray[4]["value"] == ""
                            ? 0
                            : parseInt(noDealArray[4]["value"]));
                      }
                      // if (noDealColumnIndex == 5) {
                      //   noDealArray[noDealColumnIndex]["value"] = (
                      //     (noDealArray[noDealColumnIndex - 1]["value"] /
                      //       totalTrx) *
                      //     100
                      //   ).toFixed(2);
                      // }

                      if (noDealColumnIndex == 6) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][2];
                      }
                      if (noDealColumnIndex == 7) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][3];
                      }
                      if (noDealColumnIndex == 2) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][1];
                      }
                    }
                  );
                }
              }
            }
          );
        }
      );
      originalData.tableData.noDeal.allColumns.map(
        (noDealDatarow, noDealIndex, noDealArray) => {
          noDealDatarow.map(
            (noDealDataObj, noDealColumnIndex, noDealInnerArray) => {
              if (noDealColumnIndex == 5) {
                noDealArray[noDealIndex][noDealColumnIndex]["value"] = (
                  (noDealArray[noDealIndex][noDealColumnIndex - 1]["value"] /
                    totalTrx) *
                  100
                ).toFixed(2);
              }
            }
          );
        }
      );

      if (noDealUnitValuetoAdjust > 0) {
        originalData.tableData.noDeal.allColumns[0][3]["value"] = Math.round(
          originalData.tableData.noDeal.allColumns[0][3]["value"] -
            noDealUnitValuetoAdjust
        );
        originalData.tableData.noDeal.allColumns[0][2]["value"] = Math.round(
          originalData.tableData.noDeal.allColumns[0][3]["value"] /
          (originalData["finalQuarterData"]["data"][0][4]["value"] *
            originalData["finalQuarterData"]["data"][0][5]["value"])
        );

        originalData.tableData.noDeal.allColumns[0][4]["value"] = Math.round(
          originalData.tableData.noDeal.allColumns[0][3]["value"] /
            originalData["finalQuarterData"]["data"][0][6]["value"]
        );
        totalTrx=0;
        originalData.tableData.noDeal.allColumns.map(
          (noDealDatarow, noDealIndex, noDealArray) => {
            noDealDatarow.map((noDealDataObj, noDealColumnIndex, noDealInnerArray) => {
              if (noDealColumnIndex == 5) {
                totalTrx += 
                noDealArray[noDealIndex][noDealColumnIndex - 1]["value"];
              }
            });
          }
        );

        originalData.tableData.noDeal.allColumns.map(
          (noDealDatarow, noDealIndex, noDealArray) => {
            noDealDatarow.map((noDealDataObj, noDealColumnIndex, noDealInnerArray) => {
              if (noDealColumnIndex == 5) {
                noDealArray[noDealIndex][noDealColumnIndex]["value"] = (
                  (noDealArray[noDealIndex][noDealColumnIndex - 1]["value"] /
                    totalTrx) *
                  100
                ).toFixed(2);
              }
            });
          }
        );
        // originalData.tableData.noDeal.allColumns[0][5]["value"] = (
        //   (originalData.tableData.noDeal.allColumns[0][3]["value"] / totalTrx) *
        //   100
        // ).toFixed(2);
      }
    }
    return originalData;
  }

  getPeakPatientPercentageData(originalData, userDefinedData, dealType) {
    if (dealType == "deal") {
      let totalTrx = 0;
      let totalSourceAllocation = 0;
      let multiProductImpact = 0;
      let dealUnitValuetoAdjust = 0;
      originalData.tableData.deal.allColumns.map(
        (dealDatarow, dealIndex, dealArray) => {
          totalSourceAllocation =
            totalSourceAllocation +
            (isNaN(userDefinedData[dealIndex][2]) ||
            userDefinedData[dealIndex][2] == ""
              ? 0
              : parseInt(userDefinedData[dealIndex][2]));
          multiProductImpact =
            multiProductImpact +
            (isNaN(userDefinedData[dealIndex][3]) ||
            userDefinedData[dealIndex][3] == ""
              ? 0
              : parseInt(userDefinedData[dealIndex][3]));
        }
      );
      originalData.tableData.baseline.allColumns.map(
        (baselineRow, baselineRowIndex, baselineArray) => {
          //console.log(baselineRow)
          originalData.tableData.deal.allColumns.map(
            (dealDatarow, dealIndex, dealDataArray) => {
              if (baselineRowIndex == dealIndex) {
                if (baselineRowIndex == 0) {
                  dealDatarow.map((dealDataObj, dealColumnindex, dealArray) => {
                    if (dealColumnindex == 3) {
                      //unit calculation
                      //units = peek patiant count * livestounit factor * scaling factor //need to add scaling factor

                      let unitValue =
                        originalData.finalQuarterData.data[baselineRowIndex][1][
                          "value"
                        ] *
                        (1 + userDefinedData[baselineRowIndex][1] / 100) *
                        originalData["finalQuarterData"]["data"][
                          baselineRowIndex
                        ][4]["value"] *
                        originalData["finalQuarterData"]["data"][
                          baselineRowIndex
                        ][5]["value"]; // * Lives to unit factor * scaling factor
                      if (unitValue > 0) {
                        dealArray[dealColumnindex]["value"] =
                          Math.round(unitValue);
                      } else {
                        dealArray[dealColumnindex]["value"] = 0;
                        dealUnitValuetoAdjust += Math.abs(unitValue);
                      }
                    }
                    //TRx calculation units * units to Trx

                    if (dealColumnindex == 4) {
                      dealArray[dealColumnindex]["value"] = Math.round(
                        dealArray[dealColumnindex - 1]["value"] /
                          originalData["finalQuarterData"]["data"][
                            baselineRowIndex
                          ][6]["value"]
                      );
                      totalTrx =
                        totalTrx +
                        (isNaN(dealArray[4]["value"]) ||
                        dealArray[4]["value"] == ""
                          ? 0
                          : parseInt(dealArray[4]["value"]));
                    }
                    // if (dealColumnindex == 5) {
                    //   dealArray[dealColumnindex]["value"] = (
                    //     (dealArray[dealColumnindex - 1]["value"] / totalTrx) *
                    //     100
                    //   ).toFixed(2);
                    // }

                    if (dealColumnindex == 6) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][2];
                    }
                    if (dealColumnindex == 7) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][3];
                    }
                    if (dealColumnindex == 2) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][1];
                    }
                  });
                } else {
                  dealDatarow.map((dealDataObj, dealColumnindex, dealArray) => {
                    if (dealColumnindex == 3) {
                      // unit column
                      if (totalSourceAllocation == 0) {
                        let unitValue =
                          originalData.finalQuarterData.data[
                            baselineRowIndex
                          ][2]["value"] -
                          (originalData.tableData.deal.allColumns[0][
                            dealColumnindex
                          ]["value"] -
                            //last quarter unit of client baselineArray[0][2]["value"]) *
                            originalData.finalQuarterData.data[0][2]["value"]) *
                            (100 /
                              (originalData.tableData.deal.allColumns.length -
                                1) /
                              100) +
                          (parseInt(userDefinedData[baselineRowIndex][3]) /
                            100) *
                            (originalData.tableData.deal.allColumns[0][
                              dealColumnindex
                            ]["value"] -
                              //last quarter unit of client baselineArray[0][2]["value"]); //
                              originalData.finalQuarterData.data[0][2][
                                "value"
                              ]);
                        if (unitValue > 0) {
                          dealArray[dealColumnindex]["value"] =
                            Math.round(unitValue);
                        } else {
                          dealArray[dealColumnindex]["value"] = 0;
                          dealUnitValuetoAdjust += Math.abs(unitValue);
                        }
                      } else {
                        let unitValue =
                          //competortor unit of last quarter baselineArray[baselineRowIndex][2]["value"] -
                          originalData.finalQuarterData.data[
                            baselineRowIndex
                          ][2]["value"] -
                          ((originalData.tableData.deal.allColumns[0][
                            dealColumnindex
                          ]["value"] -
                            //last quarter unit of client baselineArray[0][2]["value"]) *
                            originalData.finalQuarterData.data[0][2]["value"]) *
                            parseInt(userDefinedData[baselineRowIndex][2])) /
                            100 +
                          (parseInt(userDefinedData[baselineRowIndex][3]) /
                            100) *
                            (originalData.tableData.deal.allColumns[0][
                              dealColumnindex
                            ]["value"] -
                              //last quarter unit of client baselineArray[0][2]["value"]); //
                              originalData.finalQuarterData.data[0][2][
                                "value"
                              ]);
                        if (unitValue > 0) {
                          dealArray[dealColumnindex]["value"] =
                            Math.round(unitValue);
                        } else {
                          dealArray[dealColumnindex]["value"] = 0;
                          dealUnitValuetoAdjust += Math.abs(unitValue);
                        }
                      }
                    }
                    //TRx calculation units * units to Trx
                    if (dealColumnindex == 4) {
                      dealArray[dealColumnindex]["value"] = Math.round(
                        dealArray[dealColumnindex - 1]["value"] /
                         //need to update with final quarter
                          //baselineArray[baselineRowIndex][6]["value"]
                          originalData["finalQuarterData"]["data"][
                            baselineRowIndex
                          ][6]["value"]
                      );
                      totalTrx =
                        totalTrx +
                        (isNaN(dealArray[4]["value"]) ||
                        dealArray[4]["value"] == ""
                          ? 0
                          : parseInt(dealArray[4]["value"]));
                    }
                    // if (dealColumnindex == 5) {
                    //   dealArray[dealColumnindex]["value"] = (
                    //     (dealArray[dealColumnindex - 1]["value"] / totalTrx) *
                    //     100
                    //   ).toFixed(2);
                    // }
                    // if (dealColumnindex == 5) {
                    //   totalTrx =
                    //     totalTrx +
                    //     (isNaN(dealArray[4]["value"]) ||
                    //     dealArray[4]["value"] == ""
                    //       ? 0
                    //       : parseInt(dealArray[4]["value"]));
                    // }

                    if (dealColumnindex == 6) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][2];
                    }
                    if (dealColumnindex == 7) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][3];
                    }
                    if (dealColumnindex == 2) {
                      dealArray[dealColumnindex]["value"] =
                        userDefinedData[dealIndex][1];
                    }
                  });
                }
              }
            }
          );
        }
      );
      originalData.tableData.deal.allColumns.map(
        (dealDatarow, dealIndex, dealArray) => {
          dealDatarow.map((dealDataObj, dealColumnIndex, dealInnerArray) => {
            if (dealColumnIndex == 5) {
              dealArray[dealIndex][dealColumnIndex]["value"] = (
                (dealArray[dealIndex][dealColumnIndex - 1]["value"] /
                  totalTrx) *
                100
              ).toFixed(2);
            }
          });
        }
      );

      if (dealUnitValuetoAdjust > 0) {
        originalData.tableData.deal.allColumns[0][3]["value"] = Math.round(
          originalData.tableData.deal.allColumns[0][3]["value"] -
            dealUnitValuetoAdjust
        );
        originalData.tableData.deal.allColumns[0][2]["value"] = Math.round(
          (originalData.tableData.deal.allColumns[0][3]["value"] /
            (originalData.finalQuarterData.data[0][1]["value"] *
              originalData["finalQuarterData"]["data"][0][4]["value"] *
              originalData["finalQuarterData"]["data"][0][5]["value"]) -
            1) *
          100
        );

        originalData.tableData.deal.allColumns[0][4]["value"] = Math.round(
          originalData.tableData.deal.allColumns[0][3]["value"] /
            originalData["finalQuarterData"]["data"][0][6]["value"]
        );
        totalTrx=0;
        originalData.tableData.deal.allColumns.map(
          (dealDatarow, dealIndex, dealArray) => {
            dealDatarow.map((dealDataObj, dealColumnIndex, dealInnerArray) => {
              if (dealColumnIndex == 5) {
                totalTrx += 
                  dealArray[dealIndex][dealColumnIndex - 1]["value"];
              }
            });
          }
        );

        originalData.tableData.deal.allColumns.map(
          (dealDatarow, dealIndex, dealArray) => {
            dealDatarow.map((dealDataObj, dealColumnIndex, dealInnerArray) => {
              if (dealColumnIndex == 5) {
                dealArray[dealIndex][dealColumnIndex]["value"] = (
                  (dealArray[dealIndex][dealColumnIndex - 1]["value"] /
                    totalTrx) *
                  100
                ).toFixed(2);
              }
            });
          }
        );
      }
    } else if ((dealType == "noDeal")) {
      let totalTrx = 0;
      let totalSourceAllocation = 0;
      let multiProductImpact = 0;
      let noDealUnitValuetoAdjust = 0;
      originalData.tableData.noDeal.allColumns.map(
        (dealDatarow, dealIndex, noDealArray) => {
          
          totalSourceAllocation =
            totalSourceAllocation +
            (isNaN(userDefinedData[dealIndex][2]) ||
            userDefinedData[dealIndex][2] == ""
              ? 0
              : parseInt(userDefinedData[dealIndex][2]));
          multiProductImpact =
            multiProductImpact +
            (isNaN(userDefinedData[dealIndex][3]) ||
            userDefinedData[dealIndex][3] == ""
              ? 0
              : parseInt(userDefinedData[dealIndex][3]));
        }
      );
      originalData.tableData.baseline.allColumns.map(
        (baselineRow, baselineRowIndex, baselineArray) => {
          //console.log(baselineRow)
          originalData.tableData.noDeal.allColumns.map(
            (noDealDatarow, noDealIndex) => {
              if (baselineRowIndex == noDealIndex) {
                if (baselineRowIndex == 0) {
                  noDealDatarow.map(
                    (noDealDataObj, noDealColumnIndex, noDealArray) => {
                      if (noDealColumnIndex == 3) {
                        //unit calculation

                        //units = peek patiant count * livestounit factor * scaling factor //need to add scaling factor
                        let unitValue =
                          originalData.finalQuarterData.data[
                            baselineRowIndex
                          ][1]["value"] *
                          (1 + userDefinedData[baselineRowIndex][1] / 100) *
                          originalData["finalQuarterData"]["data"][
                            baselineRowIndex
                          ][4]["value"] *
                          originalData["finalQuarterData"]["data"][
                            baselineRowIndex
                          ][5]["value"]; // * Lives to unit factor * scaling factor
                        if (unitValue > 0) {
                          noDealArray[noDealColumnIndex]["value"] =
                            Math.round(unitValue);
                        } else {
                          noDealArray[noDealColumnIndex]["value"] = 0;
                          noDealUnitValuetoAdjust += Math.abs(unitValue);
                        }
                      }
                      //TRx calculation units * units to Trx

                      if (noDealColumnIndex == 4) {
                        noDealArray[noDealColumnIndex]["value"] = Math.round(
                          noDealArray[noDealColumnIndex - 1]["value"] /
                            //baselineArray[baselineRowIndex][6]["value"]
                            originalData["finalQuarterData"]["data"][
                              baselineRowIndex
                            ][6]["value"]
                        );
                        totalTrx =
                          totalTrx +
                          (isNaN(noDealArray[4]["value"]) ||
                          noDealArray[4]["value"] == ""
                            ? 0
                            : parseInt(noDealArray[4]["value"]));
                      }
                      // if (noDealColumnIndex == 5) {
                      //   noDealArray[noDealColumnIndex]["value"] = (
                      //     (noDealArray[noDealColumnIndex - 1]["value"] /
                      //       totalTrx) *
                      //     100
                      //   ).toFixed(2);
                      // }

                      if (noDealColumnIndex == 6) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][2];
                      }
                      if (noDealColumnIndex == 7) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][3];
                      }
                      if (noDealColumnIndex == 2) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][1];
                      }
                    }
                  );
                } else {
                  noDealDatarow.map(
                    (noDealDataObj, noDealColumnIndex, noDealArray) => {
                      if (noDealColumnIndex == 3) {
                        // unit column

                        if (totalSourceAllocation == 0) {
                          let unitValue =
                            //competortor unit of last quarter baselineArray[baselineRowIndex][2]["value"] -
                            originalData.finalQuarterData.data[
                              baselineRowIndex
                            ][2]["value"] -
                            (originalData.tableData.noDeal.allColumns[0][
                              noDealColumnIndex
                            ]["value"] -
                              //last quarter unit of client baselineArray[0][2]["value"]) *
                              originalData.finalQuarterData.data[0][2][
                                "value"
                              ]) *
                              (100 /
                                (originalData.tableData.noDeal.allColumns
                                  .length -
                                  1) /
                                100) +
                            (parseInt(userDefinedData[baselineRowIndex][3]) /
                              100) *
                              (originalData.tableData.noDeal.allColumns[0][
                                noDealColumnIndex
                              ]["value"] -
                                //last quarter unit of client baselineArray[0][2]["value"]); //
                                originalData.finalQuarterData.data[0][2][
                                  "value"
                                ]);
                          if (unitValue > 0) {
                            noDealArray[noDealColumnIndex]["value"] =
                              Math.round(unitValue);
                          } else {
                            noDealArray[noDealColumnIndex]["value"] = 0;
                            noDealUnitValuetoAdjust += Math.abs(unitValue);
                          }
                        } else {
                          let unitValue =
                          originalData.finalQuarterData.data[baselineRowIndex][2]["value"] -
                            ((originalData.tableData.noDeal.allColumns[0][
                              noDealColumnIndex
                            ]["value"] -
                              //last quarter unit of client baselineArray[0][2]["value"]) *
                              originalData.finalQuarterData.data[0][2][
                                "value"
                              ]) *
                              parseInt(userDefinedData[baselineRowIndex][2])) /
                              100 +
                            // parseInt(userDefinedData[baselineRowIndex][2]) /
                            //   100 +
                            (userDefinedData[baselineRowIndex][3] / 100) *
                              (originalData.tableData.noDeal.allColumns[0][
                                noDealColumnIndex
                              ]["value"] -
                                //last quarter unit of client baselineArray[0][2]["value"]); //
                                originalData.finalQuarterData.data[0][2][
                                  "value"
                                ]);
                          if (unitValue > 0) {
                            noDealArray[noDealColumnIndex]["value"] =
                              Math.round(unitValue);
                          } else {
                            noDealArray[noDealColumnIndex]["value"] = 0;
                            noDealUnitValuetoAdjust += Math.abs(unitValue);
                          }
                        }
                      }
                      //TRx calculation units * units to Trx
                      if (noDealColumnIndex == 4) {
                        noDealArray[noDealColumnIndex]["value"] = Math.round(
                          noDealArray[noDealColumnIndex - 1]["value"] /
                            //baselineArray[baselineRowIndex][6]["value"]
                            originalData["finalQuarterData"]["data"][
                              baselineRowIndex
                            ][6]["value"]
                        );
                        totalTrx =
                          totalTrx +
                          (isNaN(noDealArray[4]["value"]) ||
                          noDealArray[4]["value"] == ""
                            ? 0
                            : parseInt(noDealArray[4]["value"]));
                      }
                      // if (noDealColumnIndex == 5) {
                      //   noDealArray[noDealColumnIndex]["value"] = (
                      //     (noDealArray[noDealColumnIndex - 1]["value"] /
                      //       totalTrx) *
                      //     100
                      //   ).toFixed(2);
                      // }

                      if (noDealColumnIndex == 6) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][2];
                      }
                      if (noDealColumnIndex == 7) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][3];
                      }
                      if (noDealColumnIndex == 2) {
                        noDealArray[noDealColumnIndex]["value"] =
                          userDefinedData[noDealIndex][1];
                      }
                    }
                  );
                }
              }
            }
          );
        }
      );
      originalData.tableData.noDeal.allColumns.map(
        (noDealDatarow, noDealIndex, noDealArray) => {
          noDealDatarow.map(
            (noDealDataObj, noDealColumnIndex, noDealInnerArray) => {
              if (noDealColumnIndex == 5) {
                noDealArray[noDealIndex][noDealColumnIndex]["value"] = (
                  (noDealArray[noDealIndex][noDealColumnIndex - 1]["value"] /
                    totalTrx) *
                  100
                ).toFixed(2);
              }
            }
          );
        }
      );

      if (noDealUnitValuetoAdjust > 0) {
        originalData.tableData.noDeal.allColumns[0][3]["value"] = Math.round(
          originalData.tableData.noDeal.allColumns[0][3]["value"] -
            noDealUnitValuetoAdjust
        );
        originalData.tableData.noDeal.allColumns[0][2]["value"] = Math.round(
          (originalData.tableData.noDeal.allColumns[0][3]["value"] /
            (originalData.finalQuarterData.data[0][1]["value"] *
              originalData["finalQuarterData"]["data"][0][4]["value"] *
              originalData["finalQuarterData"]["data"][0][5]["value"]) -
            1) *
          100
        );

        originalData.tableData.noDeal.allColumns[0][4]["value"] = Math.round(
          originalData.tableData.noDeal.allColumns[0][3]["value"] /
            originalData["finalQuarterData"]["data"][0][6]["value"]
        );
        totalTrx=0;
        originalData.tableData.noDeal.allColumns.map(
          (noDealDatarow, noDealIndex, noDealArray) => {
            noDealDatarow.map((noDealDataObj, noDealColumnIndex, noDealInnerArray) => {
              if (noDealColumnIndex == 5) {
                totalTrx += 
                noDealArray[noDealIndex][noDealColumnIndex - 1]["value"];
              }
            });
          }
        );

        originalData.tableData.noDeal.allColumns.map(
          (noDealDatarow, noDealIndex, noDealArray) => {
            noDealDatarow.map((noDealDataObj, noDealColumnIndex, noDealInnerArray) => {
              if (noDealColumnIndex == 5) {
                noDealArray[noDealIndex][noDealColumnIndex]["value"] = (
                  (noDealArray[noDealIndex][noDealColumnIndex - 1]["value"] /
                    totalTrx) *
                  100
                ).toFixed(2);
              }
            });
          }
        );
        // originalData.tableData.noDeal.allColumns[0][5]["value"] = (
        //   (originalData.tableData.noDeal.allColumns[0][3]["value"] / totalTrx) *
        //   100
        // ).toFixed(2);
      }
    }

    return originalData;
    //return { ...originalData, originalData };
  }

  getBaselineAdoptionCurveData(perCapitaData, valueFormat, Type, product) {
    let data;
    let dividingFactor = 1;
    if (Type === "Share") {
      data = perCapitaData.TRxSharePercent.tableData.map((item) =>
        item.map((subItem) => subItem.value)
      );
    } else if (Type === "National Forecast") {
      data = perCapitaData.NationalForecast.tableData.map((item) =>
        item.map((subItem) => subItem.value)
      );
    } else {
      data = perCapitaData.TRx.tableData.map((item) =>
        item.map((subItem) => subItem.value)
      );
    }
    let dataGraph = [...data.filter((subarr) => subarr[0] === product)];
    dataGraph = dataGraph[0];
    dataGraph.shift();
    if (Type === "Volume") {
      switch (valueFormat) {
        case "Actuals":
          dividingFactor = 1;
          break;
        case "Thousands":
          dividingFactor = 1000;
          break;
        case "Millions":
          dividingFactor = 1000000;
      }
    }
    dataGraph = dataGraph.map((value) =>
      parseFloat((value / dividingFactor).toFixed(2))
    );
    return dataGraph;
  }

  async loadFormulary(scenario) {
    this.formularyData = await this.getFormularyDataForPerCapita(scenario);
  }

  private async getFormularyDataForPerCapita(scenario) {
    const newData = {};
    let products: any[] = [];
    await this.http
      .post(
        this.serverApiService.getApi.createScenario
          .getFormularyDataForPerCapita,
        { therapyArea: scenario.ProjectSummary.TherapyArea }
      )
      .toPromise()
      .then((data: any) => {
        products = [
          ...new Set(data.formularyData.map((item) => item.Product_Family)),
        ];
        products.forEach((product) => {
          newData[product] = data.formularyData
            .filter((datum) => datum.Product_Family === product)
            .map((item) => item.Access);
        });
        // this.formularyData = newData[products[0]];
      });
    return newData[products[0]];
  }
  UpdateTrxFromCreateScenario(perCapitaData, type) {
    if (type == "trx") {
      return {
        baseline: this.commonService.deepCopy(perCapitaData["TRx"]),
        deal: this.commonService.deepCopy(perCapitaData["TRx"]),
        noDeal: this.commonService.deepCopy(perCapitaData["TRx"]),
      };
    } else if (type == "trxPercentage") {
      return {
        baseline: this.commonService.deepCopy(perCapitaData["TRxSharePercent"]),
        deal: this.commonService.deepCopy(perCapitaData["TRxSharePercent"]),
        noDeal: this.commonService.deepCopy(perCapitaData["TRxSharePercent"]),
      };
    } else if (type == "units") {
      return {
        baseline: this.commonService.deepCopy(perCapitaData["units"]),
        deal: this.commonService.deepCopy(perCapitaData["units"]),
        noDeal: this.commonService.deepCopy(perCapitaData["units"]),
      };
    }
    else if (type == "unitsToTrx") {
      return {
        baseline: this.commonService.deepCopy(perCapitaData["unitsToTrx"]),
        deal: this.commonService.deepCopy(perCapitaData["unitsToTrx"]),
        noDeal: this.commonService.deepCopy(perCapitaData["unitsToTrx"]),
      };
    }
  }
  updateTrxCalulcationAllQuarter(
    trxFromCreateScenario,
    perCapitaAllData,
    adoptionCurveMonthSelected,
    adoptionCurveMonthJson,
    adoptionSelectedValue,
    userDefinedData?,
    modelimpact?
  ) {
    const temp = this.contractExpectationCalculationService.updateTrxCalculationAllQuarter(
      trxFromCreateScenario,
      perCapitaAllData,
      adoptionCurveMonthSelected,
      adoptionCurveMonthJson,
      adoptionSelectedValue,
      userDefinedData,
      modelimpact
    );
    return temp;
    let trxAllQuarterValue: any;
    if (
      perCapitaAllData.tableData.deal.limitedColumns[0][1]["value"] === 0 ||
      perCapitaAllData.tableData.deal.limitedColumns[0][1]["value"] != ""
    ) {
      trxAllQuarterValue = this.UpdateDealandNoDealTrx(
        trxFromCreateScenario,
        perCapitaAllData,
        "deal",
        adoptionCurveMonthSelected,
        adoptionCurveMonthJson,
        adoptionSelectedValue
      );
    } else {
      trxAllQuarterValue = perCapitaAllData;
    }
    if (
      perCapitaAllData.tableData.noDeal.limitedColumns[0][1]["value"] === 0 ||
      perCapitaAllData.tableData.noDeal.limitedColumns[0][1]["value"] != ""
    ) {
      trxAllQuarterValue = this.UpdateDealandNoDealTrx(
        trxFromCreateScenario,
        perCapitaAllData,
        "noDeal",
        adoptionCurveMonthSelected,
        adoptionCurveMonthJson,
        adoptionSelectedValue
      );
    } else {
      trxAllQuarterValue = perCapitaAllData;
    }
    if (
      (perCapitaAllData.tableData.noDeal.limitedColumns[0][1]["value"] === 0 ||
        perCapitaAllData.tableData.noDeal.limitedColumns[0][1]["value"] !=
          "") ||
      (perCapitaAllData.tableData.deal.limitedColumns[0][1]["value"] === 0 ||
        perCapitaAllData.tableData.deal.limitedColumns[0][1]["value"] != "")
    ) {
      trxAllQuarterValue = this.updateTrxPercentageCalulcationAllQuarter(
        trxFromCreateScenario,
        perCapitaAllData
      );
    } else {
      trxAllQuarterValue = perCapitaAllData;
    }
    return trxAllQuarterValue;
  }
  UpdateDealandNoDealTrx(
    trxFromCreateScenario,
    perCapitaAllData,
    type,
    adoptionCurveMonthSelected,
    adoptionCurveMonthJson,
    adoptionSelectedValue
  ) {
    const firstQuarter = this.getQuarter(
      trxFromCreateScenario,
      trxFromCreateScenario.contractPeriod.ContractStartDate
    );
    const lastQuarter = this.getQuarter(
      trxFromCreateScenario,
      trxFromCreateScenario.contractPeriod.ContractEndDate
    );
    let adoptionList = this.adoptionCurveCalulation(
      firstQuarter,
      lastQuarter,
      perCapitaAllData,
      type,
      adoptionCurveMonthSelected,
      adoptionCurveMonthJson,
      adoptionSelectedValue
    );
    let totalSourceAllocation = 0;
    let sourceAllocationUpdatedValue = 0;
    perCapitaAllData.tableData[type]["allColumns"].map(
      (productRow, productIndex, productArray) => {
        productRow.map((columnRow, columnIndex, columnArray) => {
          if (columnIndex == 6) {
            totalSourceAllocation +
              (isNaN(columnRow) || columnRow == "" ? 0 : parseInt(columnRow));
          }
        });
      }
    );
    perCapitaAllData.trx[type]["tableData"].map(
      (trxDealRow, trxDealIndex, trxDealArray) => {
        //client product
        if (trxDealIndex == 0) {
          trxDealRow.map(
            (trxDealInnerRow, trxDealInnerIndex, trxDealInnerArray) => {
              //between first quarter and last quarter
              if (
                trxDealInnerIndex >=
                  perCapitaAllData.trx[type].heading.indexOf(firstQuarter) &&
                trxDealInnerIndex <
                  perCapitaAllData.trx[type].heading.indexOf(lastQuarter)
              ) {
                //trx is not there in baseline so need to update it
                trxDealInnerArray[trxDealInnerIndex]["value"] =
                  // perCapitaAllData.tableData.baseline.allColumns[
                  //   trxDealIndex
                  // ][8]["value"]
                  perCapitaAllData.trx.baseline.tableData[trxDealIndex][trxDealInnerIndex]["value"]
                   +
                  (perCapitaAllData.tableData[type]["allColumns"][
                    trxDealIndex
                  ][4]["value"] -
                    perCapitaAllData.trx.baseline.tableData[trxDealIndex][
                      perCapitaAllData.trx[type].heading.indexOf(lastQuarter)
                    ]["value"]) *
                    (adoptionList[trxDealInnerIndex - perCapitaAllData.trx[type].heading.indexOf(firstQuarter)] / 100);
                //negative values for client product
                if(trxDealInnerArray[trxDealInnerIndex]["value"] < 0){
                  trxDealInnerArray[trxDealInnerIndex]["value"] = 0;
                }
              } else if (
                trxDealInnerIndex ==
                perCapitaAllData.trx[type].heading.indexOf(lastQuarter)
              ) {
                trxDealInnerArray[trxDealInnerIndex]["value"] =
                  perCapitaAllData.tableData[type]["allColumns"][
                    trxDealIndex
                  ][4]["value"];
              }
            }
          );
        } else {
          trxDealRow.map(
            (trxDealInnerRow, trxDealInnerIndex, trxDealInnerArray) => {
              //between first quarter and last quarter
              if (
                trxDealInnerIndex >=
                  perCapitaAllData.trx[type].heading.indexOf(firstQuarter) &&
                trxDealInnerIndex <
                  perCapitaAllData.trx[type].heading.indexOf(lastQuarter)
              ) {
                if (totalSourceAllocation == 0) {
                  sourceAllocationUpdatedValue =
                    100 /
                    (perCapitaAllData.tableData[type]["allColumns"].length -
                      1) /
                    100;
                } else {
                  sourceAllocationUpdatedValue =
                    perCapitaAllData.tableData[type]["allColumns"][
                      trxDealIndex
                    ][6]["value"];
                }
                //trx is not there in baseline so need to update it
                trxDealInnerArray[trxDealInnerIndex]["value"] =
                  // perCapitaAllData.tableData.baseline.allColumns[
                  //   trxDealIndex
                  // ][8]["value"]
                  (perCapitaAllData.units.baseline.tableData[trxDealIndex][trxDealInnerIndex]["value"]
                  -
                  (perCapitaAllData.trx[type]["tableData"][0][
                    trxDealInnerIndex
                  ]["value"] -
                  perCapitaAllData.trx.baseline.tableData[0][trxDealInnerIndex]["value"])* 
                  perCapitaAllData.unitsToTrx.baseline.tableData[0][trxDealInnerIndex]["value"] *
                    sourceAllocationUpdatedValue +
                  (perCapitaAllData.trx[type]["tableData"][0][
                    trxDealInnerIndex
                  ]["value"] -
                  perCapitaAllData.trx.baseline.tableData[0][trxDealInnerIndex]["value"]) * 
                  perCapitaAllData.unitsToTrx.baseline.tableData[0][trxDealInnerIndex]["value"] *
                    (perCapitaAllData.tableData[type]["allColumns"][
                      trxDealIndex
                    ][7]["value"]/100))/perCapitaAllData.unitsToTrx.baseline.tableData[trxDealIndex][trxDealInnerIndex]["value"];
                  
                  //Negative values for competitor products
                  if(trxDealInnerArray[trxDealInnerIndex]["value"] < 0){
                    perCapitaAllData.trx[type]["tableData"][0][trxDealInnerIndex]["value"] = perCapitaAllData.trx[type]["tableData"][0][trxDealInnerIndex]["value"] + trxDealInnerArray[trxDealInnerIndex]["value"];
                    if(perCapitaAllData.trx[type]["tableData"][0][trxDealInnerIndex]["value"] < 0) perCapitaAllData.trx[type]["tableData"][0][trxDealInnerIndex]["value"] = 0;
                    trxDealInnerArray[trxDealInnerIndex]["value"] = 0;
                  }
                 }
              else if (
                trxDealInnerIndex ==
                perCapitaAllData.trx[type].heading.indexOf(lastQuarter)
              ) {
                trxDealInnerArray[trxDealInnerIndex]["value"] =
                  perCapitaAllData.tableData[type]["allColumns"][
                    trxDealIndex
                  ][4]["value"];
              }
              //else condition to be added with calculated trx and share
            }
          );
        }
      }
    );
    return perCapitaAllData;
  }

  updateTrxPercentageCalulcationAllQuarter(
    trxFromCreateScenario,
    perCapitaAllData
  ) {
    let perCapitaData: any;
    if (
      perCapitaAllData.tableData.deal.limitedColumns[0][1]["value"] === 0 ||
      perCapitaAllData.tableData.deal.limitedColumns[0][1]["value"] != ""
    ) {
      perCapitaData = this.TrxSharePercentage(perCapitaAllData, "deal");
    } else {
      perCapitaAllData = this.commonService.deepCopy(perCapitaAllData);
    }
    if (
      perCapitaAllData.tableData.noDeal.limitedColumns[0][1]["value"] === 0 ||
      perCapitaAllData.tableData.noDeal.limitedColumns[0][1]["value"] != ""
    ) {
      perCapitaData = this.TrxSharePercentage(perCapitaAllData, "noDeal");
    } else {
      perCapitaAllData = this.commonService.deepCopy(perCapitaAllData);
    }
    return perCapitaData;
  }

  TrxSharePercentage(perCapitaAlldata, type) {
    let totalTrxArray = [];
    for (
      let i = 1;
      i < perCapitaAlldata["trx"][type].tableData[0].length;
      i++
    ) {
      let totalTrx = 0;
      for (let j = 0; j < perCapitaAlldata["trx"][type].tableData.length; j++) {
        totalTrx =
          totalTrx +
          parseInt(perCapitaAlldata["trx"][type].tableData[j][i]["value"]);
      }
      totalTrxArray.push(totalTrx);
    }

    perCapitaAlldata["trxPercentage"][type].tableData.map(
      (rowData, index, tableDataArray) => {
        //     let totalTrx = 0;
        //     rowData.map((innerRowData, innerIndex, innerArray) => {
        //       if (innerIndex != 0) {
        //         totalTrx =
        //           totalTrx +
        //           parseInt(
        //             perCapitaAlldata["trx"][type].tableData[index][innerIndex][
        //               "value"
        //             ]
        //           );
        //       }
        //     });
        rowData.map((innerRowData, innerIndex, innerArray) => {
          if (innerIndex != 0) {
            if (
              !isNaN(
                parseInt(innerRowData["value"]) / totalTrxArray[innerIndex - 1]
              )
            ) {
              innerRowData["value"] =
                (parseInt(
                  perCapitaAlldata["trx"][type].tableData[index][innerIndex][
                    "value"
                  ]
                ) /
                  totalTrxArray[innerIndex - 1]) *
                100;
            }
          }
        });
      }
    );

    return perCapitaAlldata;
  }

  private getQuarter(perCapitaData, contractDate) {
    const date = new Date(contractDate);
    const month = date.getMonth();
    let year: any = date.getFullYear();

    let quarter: string;

    if (month <= 2) {
      quarter = "Q1";
    } else if (month <= 5) {
      quarter = "Q2";
    } else if (month <= 8) {
      quarter = "Q3";
    } else {
      quarter = "Q4";
    }
    return quarter + "-" + year.toString().slice(-2);
  }

  adoptionCurveCalulation(
    firstQuarter,
    lastQuarter,
    perCapitaAllData,
    type,
    adoptionCurveData,
    adoptionCurveMonthJson,
    adoptionSelectedValue
  ) {
    let adotionMonth = adoptionCurveData[type];
    let adoptionCurvePercentage = [];
    let count = 3;
    perCapitaAllData.trx[type].heading.map((row, index, array) => {
      if (
        index >= array.indexOf(firstQuarter) &&
        index <= array.indexOf(lastQuarter)
      ) {
        adoptionCurvePercentage.push(100);
      }
    });
    adoptionCurvePercentage.map((row, index, array) => {
      if (
        parseInt(adotionMonth) % 3 == 0 &&
        count <
          adoptionCurveMonthJson["Uptake"][adotionMonth][
            adoptionSelectedValue[type]
          ].length
      ) {
        adoptionCurvePercentage[index] =
          adoptionCurveMonthJson["Uptake"][adotionMonth][
            adoptionSelectedValue[type]
          ][count - 1]["y"];
        count = count + 3;
      }
    });
  
    return adoptionCurvePercentage;
  }
  getFinalQuarterData(perCapitaData) {
    const eligiblePatientList = perCapitaData["eligiblePatient"][
      "tableData"
    ].filter((k) =>
      k.every(
        (e) =>
          e.value !== "Adjusted Payer Lives" &&
          e.value !== "Patient Eligibility Factor (%)" &&
          e.value !== "Total Eligible Patient Count"
      )
    );
    const units = perCapitaData["units"]["tableData"];
    const trx = perCapitaData["TRx"]["tableData"];
    const TRxSharePercent = perCapitaData["TRxSharePercent"]["tableData"];
    const livesToUnits = perCapitaData["livesToUnits"]["tableData"];
    const scalingFactor = perCapitaData["scalingFactor"]; //need to update it
    const unitsToTrx = perCapitaData["unitsToTrx"]["tableData"]; //need to update it
    const finalArray: any = [];
    const lastQuarter = this.getQuarter(
      perCapitaData,
      perCapitaData.contractPeriod.ContractEndDate
    );
    const lastQuarterIndex =
      perCapitaData["units"]["heading"].indexOf(lastQuarter);
    units.forEach((element, index) => {
      finalArray.push([
        element[0],
        eligiblePatientList[index][lastQuarterIndex],
        element[lastQuarterIndex],
        TRxSharePercent[index][lastQuarterIndex],
        livesToUnits[index][lastQuarterIndex],
        {
          value: scalingFactor[lastQuarterIndex-1],
          type: "data",
          dataType: "number",
        },
        unitsToTrx[index][lastQuarterIndex],
        {
          value: this.formularyData[0],
          type: "dropDown",
          dataType: "text",
          options: this.formularyData,
        },
        trx[index][lastQuarterIndex],
      ]);
    });
    return finalArray;
  }

  setDealChart(data:any) {
    this.dealAdoptionCurveMonth = data.dealAdoptionCurveMonth;
    this.dealAdoptionCurve = data.dealAdoptionCurve;
  }

  getDealChart(): any {
    if(this.dealAdoptionCurveMonth != null && this.dealAdoptionCurve != null)
      return {'dealAdoptionCurveMonth':this.dealAdoptionCurveMonth, 'dealAdoptionCurve':this.dealAdoptionCurve};
    return false;
  }

  setnoDealChart(data:any) {
    this.noDealAdoptionCurveMonth = data.noDealAdoptionCurveMonth;
    this.noDealAdoptionCurve = data.noDealAdoptionCurve;
  }

  getnoDealChart(): any {
    if(this.noDealAdoptionCurveMonth != null && this.noDealAdoptionCurve != null)
      return {'noDealAdoptionCurveMonth':this.noDealAdoptionCurveMonth, 'noDealAdoptionCurve':this.noDealAdoptionCurve};
    return false;
  }

  resetChart(dealOrNodeal:string){
    if(dealOrNodeal === 'deal'){
      this.dealAdoptionCurveMonth = null;
      this.dealAdoptionCurve = null;
    }else if(dealOrNodeal === 'noDeal'){
      this.noDealAdoptionCurveMonth = null;
      this.noDealAdoptionCurve = null;
    }else{
      this.dealAdoptionCurveMonth = null;
      this.dealAdoptionCurve = null;
      this.noDealAdoptionCurveMonth = null;
      this.noDealAdoptionCurve = null;
    }
  }
}
